
import { BaseService } from './baseservice';

class TrashbinServiceClass extends BaseService {
    // Teams handlers
    async loadTeams(org_id) {
        const url = '/trash/org/' + org_id + '/teams/deleted';
        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data.data;
        }

        return [];
    }

    async restoreTeam(org_id, team_id) {
        const url = '/trash/restore/teams/'+ team_id;
        const response = await this.fetch('PUT', url);

        if (response && response.data) {
            return response.data;
        }

        return false;
    }

    // Sections handlers

    async loadSections(org_id) {
        const url = '/trash/org/' + org_id + '/sections/deleted';
        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data.data;
        }

        return [];
    }

    async restoreSection(org_id, section_id) {
        const url = '/trash/restore/sections/'+ section_id;
        const response = await this.fetch('PUT', url);

        if (response && response.data) {
            return response.data;
        }

        return false;
    }
}

let TrashbinService = new TrashbinServiceClass(ENVIRONMENT.API_HOST);
export default TrashbinService;
